<template>
  <div class="up-digital-book">

    <HeadBtn :isCascade="false" :searchList='searchList' @addBtn='addBtn' @resetBtn="resetBtn" :defaultProps='defaultProps'
      :searchForm='searchForm' @searchFormData='searchFormData' :selectDict='selectDict' />

    <AddDigitalBooks @addSuccess='addSuccess' :rowData='rowData' :type='type' :form='form'
      :centerDialogVisible.sync='centerDialogVisible' :selectDict='selectDict' />

    <Table :tableData='tableData' :tableHeadList='tableHeadList' :isBooks='true' @handleDelete='handleDelete' />

  </div>

</template>
<script>
import HeadBtn from "@/views/profile/components/mine/myUpload/common/HeadBtn";
import AddDigitalBooks from "@/views/profile/components/mine/myUpload/digitalBooks/components/AddDigitalBooks";
import Table from "@/views/profile/components/mine/myUpload/common/Table";

import {
  getDictTree,
  getDigitalBookAdmin,
  delResource,
  IdGetResource
} from "@/network/resourceRequest/api";

import utils from "@/util/index";

export default {
  name: "UpDigitalBooks",
  components: {
    HeadBtn,
    AddDigitalBooks,
    Table
  },

  props: {
    //当前页面--------------------------------------------
    currentPage: {},
    //总页码--------------------------------------------
    pageTotal: {}
  },

  data() {
    return {
      tableData: [],

      //筛选条件--------------------------------------------
      fd: {
        pageNum: 1,
        pageSize: 8
      },

      //搜索条件--------------------------------------------
      searchForm: {},

      //筛选字典--------------------------------------------
      selectDict: [],

      //树形筛选结构
      defaultProps: {
        children: "children",
        label: "value",
        value: "value",
        emitPath: false
      },

      //渲染表单列表
      searchList: [
        {
          field: "name",
          type: "input",
          label: "图书名：",
          placeholder: "输入图书名"
        },
        {
          field: "author",
          type: "input",
          label: "作者：",
          placeholder: "输入作者名"
        },
        {
          field: "edition",
          type: "input",
          label: "出版社：",
          placeholder: "输入作者名"
        },
        {
          field: "category",
          type: "cascader",
          label: "分类：",
          placeholder: "请选择分类",
          optionList: []
        },
        {
          field: "language",
          type: "option",
          label: "语种：",
          placeholder: "请选择语种",
          optionList: [
            { value: "汉语", lable: "汉语" },
            { value: "英语", lable: "汉语" }
          ]
        },
        {
          field: "toll",
          type: "option",
          label: "授权：",
          placeholder: "请选择计费方式",
          optionList: [
            {
              value: 1,
              label: "免费"
            },
            {
              value: 2,
              label: "收费"
            }
          ]
        },
        {
          field: "type",
          type: "option",
          label: "类型：",
          placeholder: "请选择类型",
          optionList: [{ value: "图书", lable: "图书" }]
        }
      ],

      //添加还是修改
      type: "",
      //编辑的数据--------------------------------------------
      rowData: "",

      //表格头部--------------------------------------------
      tableHeadList: [
        {
          prop: "name",
          label: "图书名称"
        },
        {
          prop: "edition",
          label: "出版社"
        },
        {
          prop: "author",
          label: "作者"
        },
        {
          prop: "category",
          label: "分类"
        },
        {
          prop: "language",
          label: "语种"
        },
        {
          prop: "type",
          label: "类型"
        }
      ],

      //文件信息
      form: {
        name: "", //图书名称
        author: "", //作者
        edition: "", //出版社
        category: "", //分类
        language: "", //语种
        type: "", //图书类型
        toll: "", //是否收费
        openState: 1, //公开状态
        fileId: "", //文件id凭证
        fileIdList: [], //文件id列表
        coverId: "", //封面id凭证
        id: 0, //资源id
        label: "" //标签属性
      },

      //显示添加或编辑
      centerDialogVisible: false
    };
  },
  created() {
    //初始化数据--------------------------------------------
    this._initData();
    this._getTableData();
  },

  watch: {
    currentPage(newPage) {
      this.$set(this.fd, "pageNum", newPage);
      this._getTableData();
    }
  },

  methods: {
    _initData() {
      //类型:course学科,phase学段,grade年级,volume册别,edition教材版本,books_type图书分类,textbook_label教材性质,qtype题型,rtype同步资源类型,ftype文件格式类型,ptype卷库类型
      let data = {
        type: "books_type"
      };

      getDictTree(data).then(res => {
        if (res.data.success) {
          let selectDict = res.data.data;
          this.searchList.forEach((item, index) => {
            if (item.field == "category") {
              this.$set(this.searchList[index], "optionList", selectDict);
            }
          });
          this.selectDict = selectDict;
        }
      });
    },

    //添加成功更新表格
    addSuccess() {
      this._getTableData();
    },

    //添加按钮
    addBtn() {
      //文件信息
      this.form = {
        name: "", //图书名称
        author: "", //作者
        edition: "", //出版社
        category: "", //分类
        language: "", //语种
        type: "", //图书类型
        toll: "", //是否收费
        openState: 1, //公开状态
        fileId: "", //文件id凭证
        fileIdList: [], //文件id列表
        coverId: "", //封面id凭证
        id: 0, //资源id
        label: "" //标签属性
      };
      this.type = "add";
      this.centerDialogVisible = true;
    },

    //查询按钮返回的数据
    searchFormData(searchFormData) {
      this.fd = {
        pageNum: 1,
        pageSize: 8
      };
      for (const key in searchFormData) {
        if (
          searchFormData.hasOwnProperty(key) &&
          searchFormData[key] &&
          searchFormData[key] != "全部"
        ) {
          this.fd[key] = searchFormData[key];
        }
      }
      this._getTableData();
    },

    //添加成功更新表格
    addSuccess() {
      this.$emit("update:currentPage", 1);
      this._getTableData();
    },

    //重置表格数据
    resetBtn() {
      this.searchForm = {};
      this.fd = {
        pageNum: 1,
        pageSize: 8
      };
      this.$emit("update:currentPage", 1);
      this._getTableData();
    },

    //获取表格数据--------------------------------------------
    _getTableData() {
      getDigitalBookAdmin(this.fd).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list;
          this.$emit("update:pageTotal", res.data.data.total);
        } else {
          console.log("CoTextbook", res.data.code);
        }
      });
    },

    //取消收藏 (1编辑  2删除)
    handleDelete(scope, type) {
      if (type == 1) {
        IdGetResource("books", scope.row.id).then(res => {
          this.rowData = res.data.data;
          this.type = "set";
          this.form.id = res.data.data.id;
          for (const key in this.form) {
            if (this.form.hasOwnProperty(key)) {
              this.$set(
                this.form,
                key,
                res.data.data.hasOwnProperty(key) ? res.data.data[key] : ""
              );
            }
          }
          this.centerDialogVisible = true;
        });
      }

      //删除
      if (type == 2) {
        delResource("books", scope.row.id).then(res => {
          if (res.data.success) {
            utils.tips("success", res.data.code);
            //更新
            this._getTableData();
          } else {
            console.log("CoTextbook", res.data.code);
          }
        });
      }
    },

    //返回label
    backLabel(label) {
      //phase学段,grade年级,volume册别,edition教材版本,textbook_label教材性质
      switch (label) {
        case "phase":
          return "学段";
          break;
        case "course":
          return "科目";
          break;
        case "grade":
          return "年级";
          break;
        case "volume":
          return "册别";
          break;
        case "edition":
          return "教材版本";
          break;
        case "textbook_label":
          return "教材性质";
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
</style>